import React, { useEffect, useState } from "react";
import api from "../../seller-apis/api";
import '../order.css';
import { useAlert } from "react-alert";
import { formatedDate } from "../../utilities/ConvertDateFormat";
import { useSelector } from "react-redux";
import { fetchReviewsData } from '../../seller-apis/apidataField';
import PaginationNew from "../common/Pagination";
import servicesApi from '../../seller-apis/servicesApi';
import Popup from '../common/Popup';
import PopupReviewMedia from '../common/PopupReviewMedia';
import { useHistory } from "react-router-dom";
var globalFilterData = {
  pageNo: 1,
  size: 12,
  filter: {
    "type": "CUSTOMER"
  },
  sortFilter: {"createdAt":-1 },
};
function CustomerReviews() {
  const history = useHistory();
  const alert=useAlert();
  // const [showModal, setShowModal] = useState(false);
  // const [showRequestModal, setShowRequestModal] = useState(false);
  const [tickets, setTickets] = useState([]);
  // const [ticket, setTicket] = useState(null);
  // const [ticketForFilter, setTicketForFilter] = useState([]);
  // const [descs, setDescs] = useState([]);
  // const [showModalDescription, setShowModalDescription] = useState(false);
  var currentDate = new Date();

  // Get the date before 15 days
  var before15Days = new Date();
  before15Days.setDate(currentDate.getDate() - 30);

  // Format the dates as strings (optional)
  var currentDateStr = currentDate.toISOString().split("T")[0];
  var before15DaysStr = before15Days.toISOString().split("T")[0];
  const [sortdatefrom, setsortdatefrom] = useState(before15DaysStr);
  const [sortdateto, setsortdateto] = useState(currentDateStr);
  const [minValDate, setMinValDate] = useState("2023-08-01");
  // const [orderId, setOrderId] = useState("");
  const [totalRcord, setTotalReord] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  // const stateData=useSelector(state=>state);
  const statusCheck=['open','reopen','repene'];
  const reviewsArr = [1,2,3,4,5];
  const [reviewImages, setReviewImages] = useState([]);
  const [reviewVideos, setReviewVideos] = useState([]);
  // const handleOpenModal = () => {
  //   setShowModal(true);
  // };

  // const handleCloseModal = () => {
  //   setShowModal(false);
  //   setShowRequestModal(false);
  // };

  useEffect(() => {
    if (localStorage.getItem("vendorState") === "partialInactive") {
      history.replace("/home");
      return false;
    }
    // let filterData = globalFilterData;

    globalFilterData.filter["from-createdAt"] = sortdatefrom + "T00:00:00";
    globalFilterData.filter["to-createdAt"] = sortdateto + "T23:59:59";
    api.Reviews.fetchReviews(fetchReviewsData(globalFilterData)).then(res => {
      console.log("fetchReviews res: ", res);
      setTickets(res.data);
      // const uniqueObjects = [];
      // const uniqueIds = new Set();

      // ticket.data.forEach((obj) => {
      //   if (!uniqueIds.has(obj.issue)) {
      //     uniqueIds.add(obj.issue);
      //     uniqueObjects.push(obj);
      //   }
      // });
      // setTicketForFilter(uniqueObjects);
    });
  }, []);
  const getSupportTicket = (filterData) => {
    api.Reviews.fetchReviews(fetchReviewsData(filterData)).then((review) => {
      setTotalReord(review.totalRecords);
      // const trueValues = [];
      // const falseValues = [];
      let data=review.data;
      // // Iterate through the original array and separate objects based on status
      // data.forEach(item => {
      //   if (item.adminMsgInfo?.vendorViewed) {
      //     trueValues.push(item);
      //   } else {
      //     falseValues.push(item);
      //   }
      // });
      // const reorderedData = falseValues.concat(trueValues);
      setTickets(data);
    });
  };
  const dateFilter = (e) => {
    if(sortdatefrom === undefined || sortdateto === undefined || sortdateto === "" || sortdatefrom === "") { 
      alert.show("please select both date");
    }
    if (sortdatefrom !== undefined && sortdateto !== undefined && sortdatefrom !== "" && sortdateto !== "") {
      let fromDate = new Date(sortdatefrom)
      let toDate = new Date(sortdateto);
      let diffDate = toDate.getTime() - fromDate.getTime()
      let daydiffer = diffDate / (1000 * 60 * 60 * 24);
      daydiffer = Math.floor(daydiffer)
      if(daydiffer > 30){
          alert.info("Date range cannot be more than 30 days.")
          return 0;
      }
    }
    let filterData = globalFilterData;

    filterData.filter["from-createdAt"] = sortdatefrom + "T00:00:00";
    filterData.filter["to-createdAt"] = sortdateto + "T23:59:59";

    getSupportTicket(filterData);
  };
  const applyFilter = (data) => {
    let filterData = globalFilterData;
    if (data != "all") {
      filterData.filter["status.label"] = data;
    } else {
      filterData.filter["status.label"] = "";
    }
    getSupportTicket(filterData);
  };
  // const applyIssueFilter = (e) => {
  //   let filterData = globalFilterData;
  //   if (e.target.value != "") {
  //     filterData.filter["issue"] = e.target.value;
  //   } else {
  //     filterData.filter["issue"] = "";
  //   }
  //   getSupportTicket(filterData);
  // };
  // useEffect(()=>{
  //   getSupportTicket(globalFilterData);
  // },[stateData.ActionReducer.sellerCount]);

  function paginate(data) {
    // console.log(data);
    setCurrentPage(data.number);
    // let filterProduct = {
    //   pageNo: data.number,
    //   filter: { status: "draft" },
    // };
    let filter=globalFilterData;
    filter['pageNo']=data.number;
    getSupportTicket(filter);
  }

  // For detail of product
  const detailnew = (url, price) => {
    let data =
    {
      "filter": { "urlKey": url }
    }
    servicesApi.getProductDetail(data).then((res) => {
      detail([res.data], price)

      setpopupVisibilityDetail("2");
    }).catch(err => console.log(err))

  }

  // For detail of product
  const mediaView = (mediaArr) => {
    let images = [];
    let videos = [];
    mediaArr.forEach(med => {
      if (med.image) {
        images.push(med);
      } else {
        videos.push(med);
      }
    });
    setReviewImages(images);
    setReviewVideos(videos);
    setMediaPopupVis("block");
  }

  //Product Detail Popup

  const [productDetail, setproductDetail] = useState([
    {
      "description": undefined,
      "sdescription": undefined,
      "name": undefined,
      "price": undefined,
      "SKU": undefined,
      "popupVisibility": undefined,
      "images": []
    }
  ]);
  const [isDetailPopupVis, setisDetailPopupVis] = useState("block");
  const [mediaPopupVis, setMediaPopupVis] = useState("block");
  const [detailPPrice, setdetailPPrice] = useState("");
  // Popup showing detail
  function detail(data, price) {
    setdetailPPrice(price)
    console.log(data)
    if (data && data[0] === undefined) {
      setproductDetail(
        [
          {
            "description": "No details available",
            "sdescription": "No short description",
            "name": undefined,
            "price": undefined,
            "SKU": undefined,
            "popupVisibility": undefined,
            "images": []
          }
        ]
      )
    }
    else {
      setproductDetail(data)
    }
  }
  
  //Popup related functions
  function setpopupVisibilityDetail(e) {
    if (e) {
      setisDetailPopupVis("block")
    }
    else {
      setisDetailPopupVis("none")
    }
  }

  //Media popup related functions
  function setMediaPopupVisibilityDetail(e) {
    if (e) {
      setMediaPopupVis("block")
    }
    else {
      setMediaPopupVis("none")
    }
  }

  return (
    <>
      <div className="d-flex mb-3 justify-content-start">
        {/* ******** */}
        <div className="theme-shed1 p-2">
          <div className="m-auto mt-1">
            <span className="payment_dates">
              From: -{" "}
              <input
                type="date"
                min={minValDate}
                value={sortdatefrom}
                onChange={(e) => setsortdatefrom(e.target.value)}
              ></input>
            </span>
            <span className="mx-2 payment_dates">
              To: -{" "}
              <input
                type="date"
                min={minValDate}
                value={sortdateto}
                onChange={(e) => setsortdateto(e.target.value)}
              ></input>
            </span>
            <span>
              <button
                className="apply-btn px-3 py-1 ff_Pop fs-14"
                onClick={() => dateFilter()}
              >
                Apply
              </button>
            </span>
            {/* <span><button className={`payment_btn_export px-3 py-1 ff_Pop fs-14 ms-1 ${removeFilterClass}`} onClick={() => clearFilters()}>Clear</button></span> */}
          </div>
        </div>
        {/* ****** */}
      </div>
      <div className="table-responsive">
      <table className="ord_table new-table-design" style={{ "width": "100%" }}>
        <thead>
          <tr>
            <th>Order ID</th>
            <th>
              Image
            </th>
            <th>
              Product
            </th>
            <th>Product Rating</th>
            <th>Package Rating</th>
            <th>Review by Customer</th>
            <th>Media</th>
            {/* <th>Status</th> */}
            {/* <th>Action</th> */}
          </tr>
        </thead>
        <tbody>
          {tickets.length > 0 && tickets.map((ticket, index) => {
            let baseImg;
            ticket.product.images.map((item) => {
              if (item.baseImage === true) {
                if (item.image.startsWith("products")) {
                  baseImg = item.image;
                }
                else {
                  let img = item.image.substr("41")
                  baseImg = img;
                }
              }
            })
            return (
              <tr className={ticket?.adminMsgInfo?.vendorViewed==false && statusCheck.includes(ticket?.status?.label.toLowerCase()) ? "active-ticket":""}>
                <td>
                  <div className='border-x'>
                    <div class="order-id">{ticket.orderId}</div>
                    <div className='order-date'>Review received date:</div>
                    <div className='order-date'>{formatedDate(ticket.createdAt)}</div>
                  </div>
                </td>
                <td>
                  <div className='border-x'>
                    <img src={"https://s3.toolsvilla.com/" + baseImg} alt="img" className="px-2 product-i mx-1" />
                  </div>
                </td>
                <td className='fs-13 order_table_pname_cntn'>
                  <div className='border-x inline-initial'>
                    <a href='#popupDetail' onClick={() => detailnew(ticket?.product?.urlKey, ticket?.product?.price)} className='prod-name'>{ticket.product.productName}</a>
                    <div className='order_table_sku'>SKU:- {ticket.product.SKU}</div>
                    <a href='#popupDetail' onClick={() => detailnew(ticket?.product?.urlKey, ticket?.product?.price)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
                  </div>
                </td>
                <td>
                  <div className='border-x'>
                    <p className="theme-col fs-12 f-700 mb-0">
                      <span className="text-yellow">
                        { reviewsArr.map((rev) => (
                          rev <= ticket.ratings ? <i className="fa fa-star "></i> : 
                          <i className="fa fa-star gry"></i>
                        ))}
                      </span>
                    </p>
                  </div>
                </td>
                <td>
                  <div className='border-x'>
                    <p className="theme-col fs-12 f-700 mb-0">
                      <span className="text-yellow">
                        { reviewsArr.map((rev) => (
                          rev <= ticket.packageRatings ? <i className="fa fa-star "></i> : 
                          <i className="fa fa-star gry"></i>
                        ))}
                      </span>
                    </p>
                  </div>
                </td>
                <td>
                  <div className='box reviewTxt'>
                    {ticket.review}
                  </div>
                </td>
                <td>
                  <div className='border-x'>
                    {ticket.media && ticket.media.length>0?<a href='#mediaPopupDetail' onClick={() => mediaView(ticket.media)} className='detail-but'>
                      <button className='px-1 order_table_btn_details'>Click here to view</button>
                    </a>:"Not Available"}
                    {/* Media */}
                  </div>
                </td>
                {/* <td>
                  <div className='border-x'>
                    {ticket.status}
                  </div>
                </td>
                <td>
                  <div className='border-x'>
                    Chat with buyer
                  </div>
                </td> */}
              </tr>
            );
          })}
          {tickets.length == 0 ? (
            <tr>
              <td colspan="6" className="text-center">
                No data found
              </td>
            </tr>
          ) : (
            ""
          )}
        </tbody>
      </table>
      </div>
      <PaginationNew
        number={totalRcord}
        paginate={paginate}
        activ={currentPage}
        comp={"support"}
      />

      <div id="popupDetail" className="overlay" style={{ "display": isDetailPopupVis }}>
        <Popup
          from="newOrder"
          description={productDetail[0].description}
          sdescription={productDetail[0].shortDescription}
          descriptionNew={productDetail[0].descriptionNew}
          specificationNew={productDetail[0].specificationNew}
          name={productDetail[0].productName}
          price={detailPPrice}
          SKU={productDetail[0].SKU}
          popupVisibility={setpopupVisibilityDetail}
          images={productDetail[0].images}
          videos={productDetail[0].videos}
        />
      </div>
      <div id="mediaPopupDetail" className="overlay" style={{ "display": mediaPopupVis }}>
        <PopupReviewMedia
          // from="newOrder"
          // description={productDetail[0].description}
          // sdescription={productDetail[0].shortDescription}
          // descriptionNew={productDetail[0].descriptionNew}
          // name={productDetail[0].productName}
          // price={detailPPrice}
          // SKU={productDetail[0].SKU}
          popupVisibility={setMediaPopupVisibilityDetail}
          images={reviewImages}
          videos={reviewVideos}
        />
      </div>
    </>
  );
}

export default CustomerReviews;
